module.exports = __webpack_public_path__ + "img/bg-safety-speed-01.png";